<div *ngIf="showSections" class="row no-gutters anchors-set" [class.sticky]="isScrolled == true" [class.stickyAllView]="isScrolled == true && showChangeView == true" [class.absolute]="isScrolled == false">
    <div class="col">
        <div class="section-icons-container">
            <ng-container *ngFor="let section of sections">
                <div class="icon {{getLabelClass(section.label)}}" (click)="changeUrl(section.anchor); scrollTo(section.anchor)" *checkPermission="section.permission">
                    <span attr.data-hover="{{section.label | translate}}"><img [src]="section.icon" alt="{{section.label | translate}}"></span>
                </div>
            </ng-container>
            <div *ngIf="showChangeView" style="background: black !important" class="icon" (click)="changeViewEvent.emit(true)"  ngbTooltip="{{'person.tabs.tabsView' | translate}}" placement="left" container="body"  triggers="hover"
            tooltipClass="apc-tooltip-left">
                <div attr.data-hover="Change View"><img [src]="'assets/ico/table-columns-solid.svg'" alt="Change View"></div>
            </div>
        </div>
    </div>
</div>